import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 8H14M8 2V14",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgPlus;
